module.exports = __webpack_public_path__ + "img/sheretitle.d9b0127f.png";